import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RPEList } from "../../calendar/session-rpe/RPEList";
import { mapUtcToDatePicker } from "../../../../utils/daily-stats";
import BarGraph from "./BarGraph";
import { round, upperFirst } from "lodash";

const GraphSummary = ({ dateFrom, dateTo, stats, field, units = null }) => {
  const { t } = useTranslation("athlete-portal");
  const [listState, setListState] = useState([]);
  const [sortedRecentState, setSortedRecentState] = useState(false);

  const filteredStats = stats.filter((stat) => !!stat[field]);

  const sortedStats = [...filteredStats].sort((a, b) => a.utcDate - b.utcDate);

  const average = round(
    filteredStats.reduce((acc, prev) => acc + prev[field], 0) /
      filteredStats.length,
    0
  );

  useEffect(() => {
    const statsList = mapUtcToDatePicker({
      stats: filteredStats,
      fieldToConvert: "utcDate",
      newField: "date",
    });
    setListState(statsList);

    setSortedRecentState(true);
  }, []);

  const sortList = ({ dateFormattedData: sortedStats, sortedRecent }) => {
    setListState(sortedStats);
    setSortedRecentState(sortedRecent);
  };

  const columnsData = [
    {
      name: t("nutritionPage.date"),
      field: "date",
      columnClass: "date",
      itemClass: "date",
    },
    {
      name: `${upperFirst(field)}${units ? ` (${units})` : ""}`,
      field: field,
      columnClass: field,
      itemClass: field,
    },
  ];

  return (
    <div className="nutrition-summary-graph-container">
      {filteredStats.length ? (
        <React.Fragment>
          <div className="nutrition-summary-graph-header">
            <p className="s3">{upperFirst(field)}</p>
            <div className="average">
              <p className="s1">{t("nutritionPage.average")}</p>
              <b>
                <span className="hr-value">
                  {" "}
                  {average || 0} {units ? `${units}` : ""}
                </span>
              </b>
            </div>
          </div>

          <BarGraph
            key={`${field}-graph`}
            targetValue={field}
            data={sortedStats}
            average={average}
          />
          <div className="flex-wrapper">
            <RPEList
              dateFrom={dateFrom}
              dateTo={dateTo}
              list={listState}
              customClass={"bodyweight"}
              columnsData={columnsData}
              highlightedElem={""}
              sortedRecent={sortedRecentState}
              updateState={sortList}
            />
          </div>
        </React.Fragment>
      ) : (
        <div className="empty-state h-full">
          <span className="font-bold">{t("nutritionPage.noDataToShow")}</span>
        </div>
      )}
    </div>
  );
};

export default GraphSummary;
